import PrepWorkflowModel from "@/models/lab/PrepWorkflowModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class PrepWorkflowCollection extends LabServiceCollection {
  model() {
    return PrepWorkflowModel;
  }

  prepareFilter(CollectionFilter) {

    return CollectionFilter;
  }
}
